import { Box, Button, Container, Paper } from '@mui/material'
import { useAsyncEffect } from '@xylabs/sdk-react'
import { Erc721MetaJson, Quadkey } from '@xyo-network/sdk-xyoworld-js'
import { useContext, useState } from 'react'
import { Helmet } from 'react-helmet'
import JsonView from 'react-json-view'
import { Link, useParams } from 'react-router-dom'

import { AuctionProvider, GeotokenProvider, GeotokensContext, useGeotoken } from '../Contexts'
import WorldBasePage from './WorldBasePage'

interface DetailsProps {
  quadkey: Quadkey
}

const Details: React.FC<DetailsProps> = (props) => {
  const { quadkey } = props
  const geotoken = useGeotoken()
  const [jsonObject, setJsonObject] = useState<Erc721MetaJson>()

  useAsyncEffect(
    // eslint-disable-next-line react-hooks/exhaustive-deps
    async (isMounted) => {
      console.log(`Details: ${JSON.stringify(geotoken)}`)
      if (geotoken) {
        console.log('getErc721MetaData')
        const json = (await geotoken.getErc721MetaData()).toJsonObject()
        if (isMounted()) {
          setJsonObject(json)
        }
      } else {
        setJsonObject({ description: 'Arie' })
      }
    },
    [geotoken],
  )

  return (
    <Box padding={2}>
      <Paper>
        <Box bgcolor="white" margin={2} padding={2}>
          {jsonObject ? <JsonView src={jsonObject} /> : null}
        </Box>
        <Box display="flex" justifyContent="space-between" padding={1}>
          <Button component={Link} to={`/geotoken/${quadkey.toBase4HashLabel()}`}>
            Back
          </Button>
          <Button component={Link} to={'/auctions/json'}>
            All
          </Button>
          <Button>Refresh</Button>
        </Box>
      </Paper>
    </Box>
  )
}

const GeotokenJsonPage: React.FC = () => {
  const { id } = useParams()
  const quadkeyRequested = (id === 'fhr' ? Quadkey.root : Quadkey.fromBase4String(id)) ?? Quadkey.root

  const { geotokens } = useContext(GeotokensContext)

  console.log(`GeotokenJsonPage: ${geotokens}`)

  return (
    <WorldBasePage>
      <AuctionProvider quadkey={quadkeyRequested}>
        <GeotokenProvider quadkey={quadkeyRequested}>
          <Helmet title="Geotoken Json" />
          <Container>
            <Details quadkey={quadkeyRequested} />
          </Container>
        </GeotokenProvider>
      </AuctionProvider>
    </WorldBasePage>
  )
}

export default GeotokenJsonPage
